import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { Link } from "react-router-dom";
import { Experience } from "types";

interface PromptModalProps {
    isGlobalWarning?: boolean;
    isProductWarning?: boolean;
    experience?: Experience;
    onClose: (e: any) => void;
    isOpen: boolean;
}

export const QuestionnaireWarningModal = ({
    isOpen,
    isGlobalWarning = false,
    isProductWarning = false,
    experience,
    onClose,
}: PromptModalProps) => {
    const path = experience ? `/products/experiences/${experience.id}/questionnaire` : "";
    const globalQuestionnairePath = `/products/globalSettings/questionnaire`;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Unable to complete action</Modal.Header>

            <Modal.Body>
                {isProductWarning ? (
                    <>
                        This experience&apos;s questionnaire includes guest-specific questions. To disable unique guest
                        identification, only organizer-specific questions can be included. Please update the{" "}
                        <Link to={path} className="text-primary underline">
                            questionnaire for this experience
                        </Link>{" "}
                        before proceeding.
                    </>
                ) : !isProductWarning && isGlobalWarning ? (
                    <>
                        This experience uses global questionnaire which includes guest-specific questions. To disable
                        unique guest identification, either update the{" "}
                        <Link to={globalQuestionnairePath} className="text-primary underline">
                            global questionnaire
                        </Link>{" "}
                        to include only organizer-specific questions or override the questionnaire for this experience
                        to do the same.
                    </>
                ) : (
                    <>
                        <Link to={globalQuestionnairePath} className="text-primary underline">
                            Global Questionnaire
                        </Link>{" "}
                        includes guest-specific questions. To disable global questionnaire overriding you need to turn
                        on <strong>“Uniquely identify each attendee in the reservation”</strong> in the Guest Management
                        Tab.
                    </>
                )}{" "}
            </Modal.Body>

            <Modal.Footer>
                <fieldset className="flex justify-end space-x-4">
                    <SubmitButton type="submit" variant="outline" color="secondary" onClick={onClose}>
                        Close
                    </SubmitButton>
                </fieldset>
            </Modal.Footer>
        </Modal>
    );
};
